import React from 'react';
import classNames from 'classnames';
import { APPEARANCES } from './constants';
const Divider = ({ appearance = APPEARANCES.default }) => {
  const dividerClasses = classNames('ws-ui-divider', `ws-ui-divider--appearance-${appearance}`);

  return <hr className={dividerClasses} />;
};

export default Divider;
